module.exports = __webpack_public_path__ + "img/Home_Tablet_02.0cba34d0.jpg";